import { MoreOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { getPermissionByEntityType } from 'library/helpers/getPrimary';
import useManagePermittedRoles from 'library/hooks/useManagePermittedRoles';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { DeleteAddressModal } from 'zComponents/molecules';
import { Button, Card, Col, Dropdown, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;
const EntityAddressTab = ({ address, data, type, handleAddress }) => {
	// Redux state
	const { addressTypes } = useSelector((state) => state.Types);

	// Hooks
	const { permissionName, rules } = getPermissionByEntityType(type, data);
	const isPermittedUpdate = useManagePermittedRoles(permissionName, rules);

	// Local State
	const [deleteContactVisible, setDeleteContactVisible] = useState(false);
	const [selectedContact, setSelectedContact] = useState(false);

	const items = (item) => [
		{
			key: 'edit',
			label: (
				<Tooltip title={!isPermittedUpdate ? "You don't have permission" : 'Edit Address'}>
					<Button
						size={'small'}
						onClick={() => handleAddress(item)}
						disabled={!isPermittedUpdate}
						style={{ width: '100%' }}
					>
						Edit
					</Button>
				</Tooltip>
			)
		},
		{
			key: 'delete',
			label: (
				<Tooltip title={!isPermittedUpdate ? "You don't have permission" : 'Delete Address'}>
					<Button
						size={'small'}
						onClick={() => {
							setDeleteContactVisible(true);
							setSelectedContact({ ...item, ...data });
						}}
						disabled={!isPermittedUpdate}
						style={{ width: '100%' }}
						danger
					>
						Delete
					</Button>
				</Tooltip>
			)
		}
	];

	return (
		<Row gutter={[8, 8]}>
			{address && address.length > 0 ? (
				address.map((item, key) => (
					<Col key={key} lg={12} md={12} sm={12} xs={12}>
						<Card
							size='small'
							title={
								addressTypes?.find((address) => address.addressTypeID === item.addressTypeID).name ||
								'Default'
							}
							extra={
								<Dropdown
									menu={{
										items: items(item)
									}}
									trigger={['click']}
								>
									<MoreOutlined />
								</Dropdown>
							}
							style={{ height: '100%' }}
						>
							<Flex vertical>
								<Text>{item.addressLine1}</Text>
								{item.addressLine2 !== 'null' && <Text>{item.addressLine2}</Text>}
								<Text>
									{item.suburb} {item.state} {item.postCode}
								</Text>
							</Flex>
						</Card>
					</Col>
				))
			) : (
				<Col span={24}>
					<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span>No Address Added</span>} />
				</Col>
			)}
			<DeleteAddressModal
				visible={deleteContactVisible}
				setVisible={setDeleteContactVisible}
				data={selectedContact}
				type={type}
			>
				<div />
			</DeleteAddressModal>
		</Row>
	);
};

export default EntityAddressTab;
